import React from "react";

const UNIT_TRANSLATIONS = {
    count: "عدد",
    package: "بسته",
    weight: "کیلوگرم",
    length: "متر",
    area: "متر مربع",
    litr: "لیتر",
    volume: "متر مکعب",
  };

const badgeClassMap = {
  active: "bg-green-100 text-green-700",
  inactive: "bg-red-100 text-red-700",
};

const renderStatusBadge = (
  active,
  activeText = "فعال",
  inactiveText = "غیرفعال"
) => {
  return (
    <span
      className={`inline-flex rounded-full px-2 py-1 text-[11px] font-medium ${
        active ? badgeClassMap.active : badgeClassMap.inactive
      }`}
    >
      {active ? activeText : inactiveText}
    </span>
  );
};

const formatPrice = (value) => {
  if (value === null || value === undefined || value === "") return "-";
  return Number(value).toLocaleString("fa-IR");
};

const translateUnit = (unit) => {
  if (!unit) return "---";
  return UNIT_TRANSLATIONS[String(unit).toLowerCase()] || unit;
};

const InventoryRow = ({ item }) => {
  return (
    <tr className="align-middle border-b border-gray-100 transition hover:bg-gray-50">
      <td className="px-3 py-3">
        {item.featured_image_url ? (
          <img
            src={item.featured_image_url}
            alt={item.name}
            className="h-12 w-12 rounded-lg border border-gray-200 object-cover"
          />
        ) : (
          <div className="flex h-12 w-12 items-center justify-center rounded-lg border border-gray-200 bg-gray-100 text-[10px] text-gray-400">
            بدون عکس
          </div>
        )}
      </td>

      <td className="px-3 py-3">
          <div className="flex min-w-[240px] max-w-[320px] flex-col gap-1.5 text-xs text-gray-500">
              <div className="flex items-start justify-between gap-2">
                  <div className="min-w-0">
                      <div
                          className="truncate text-sm font-semibold text-gray-900"
                          title={item.name || "---"}
                      >
                          {item.name || "---"}
                          {!item.is_active && (
                              <span
                                  className="shrink-0 rounded-full bg-red-100 px-1.5 py-0.5 text-[10px] font-medium text-red-600">
                  غیرفعال
                </span>
                          )}
                      </div>

                      <div className="mt-0.5 text-[11px] text-gray-400">
                          کد کالا: {item.product_code || item.code || "---"}
                      </div>
                  </div>

                  <span className="shrink-0 rounded-md bg-gray-100 px-2 py-1 text-[11px] text-gray-700">
              {translateUnit(item.unit_of_measure)}
            </span>
              </div>

              <div className="flex items-center justify-between gap-2 text-[11px]">
                <span className="truncate rounded bg-blue-50 px-1 text-blue-700">
                  {item.category_name || "---"}
                </span>
                      <span className="truncate text-gray-400">
                  برند:{" "}
                          <strong className="font-medium text-gray-600">
                    {item.brand || "---"}
                  </strong>
                </span>
              </div>
          </div>
      </td>

        <td className="px-2 py-3">
            <div className="text-sm text-gray-700">
                <div className="truncate font-medium text-gray-800">
                    {item.supplier?.full_name || "---"}
                </div>
                {item.supplier?.phone_number && (
                    <div className="mt-0.5 text-[11px] text-gray-400" dir="ltr">
                        {item.supplier.phone_number}
                    </div>
                )}
            </div>
        </td>

        <td className="px-2 py-3">
        <div className="text-sm text-gray-700">
          <div className="truncate font-medium text-gray-800">
            {item.warehouse?.title || "---"}
          </div>
          {item.warehouse?.city && (
            <div className="mt-0.5 text-[11px] text-gray-400">
              {item.warehouse.city}
            </div>
          )}
        </div>
      </td>

      <td className="whitespace-nowrap px-2 py-3 text-sm text-gray-700">
        {item.stock ?? 0}
      </td>

      <td className="whitespace-nowrap px-2 py-3 text-sm font-medium text-gray-800">
        {formatPrice(item.price)}
      </td>

      <td className="whitespace-nowrap px-2 py-3 text-sm text-gray-700">
        {item.discount_percent ?? 0}٪
      </td>

      <td className="whitespace-nowrap px-2 py-3 text-sm text-gray-700">
        {item.min_order ?? "-"}
      </td>

      <td className="whitespace-nowrap px-2 py-3 text-sm text-gray-700">
        {item.max_order ?? "-"}
      </td>

      <td className="whitespace-nowrap px-2 py-3 text-sm text-gray-700">
        {item.order_multiple ?? "-"}
      </td>

      <td className="px-2 py-3 text-sm">
        {renderStatusBadge(
          item.inventory_is_active,
          "فعال",
          "غیرفعال"
        )}
      </td>
    </tr>
  );
};

export default InventoryRow;
